/**
 * Formulario de inicio de sesión con campos de email y contraseña.
 */
import React from "react";
import { Button, Form, Input } from "antd";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";

const LoginForm = ({
  form,
  loading,
  onFinish,
  handleForgotPassword,
  onLoading,
  loginError,
  setLoginError,
}) => {
  return (
    <Form
      requiredMark={false}
      form={form}
      layout="vertical"
      name="login-form"
      onFinish={onFinish}
      autoComplete="off"
      onValuesChange={() => {
        if (loginError) {
          setLoginError();
        }
      }}
    >
      <Form.Item name="user" rules={[{ required: true, message: "Por favor ingresa tu usuario" }]}>
        <Input
          prefix={<UserOutlined className="onefin-input-icon" />}
          placeholder="Usuario"
          className="onefin-login-input"
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "Por favor ingresa tu contraseña",
          },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined className="onefin-input-icon" />}
          placeholder="Contraseña"
          className="onefin-login-input"
        />
      </Form.Item>

      {loginError && <div className="onefin-login-error">{loginError.message}</div>}

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          icon={<LoginOutlined />}
          block
          className="onefin-login-btn"
          onClick={() => {
            const { user, password } = form.getFieldsValue();
            if (user && password) onLoading();
          }}
        >
          Ingresar
        </Button>
      </Form.Item>

      <div style={{ textAlign: "center", marginTop: 12 }}>
        <span
          className="onefin-forgot-link"
          onClick={handleForgotPassword}
          style={{ cursor: "pointer" }}
        >
          ¿Olvidaste tu contraseña?
        </span>
      </div>
    </Form>
  );
};

export default LoginForm;
